import { createFileRoute } from '@tanstack/react-router'
import { ComponentDemos } from './-components/admin/component-demos'
import { ComponentsPending } from './-components/admin/admin-pending'

export const Route = createFileRoute('/_app/admin/components')({
  component: ComponentDemos,
  pendingComponent: ComponentsPending,
})
